import { $http } from './http'

export interface ReservedInventoryItem {
  productId: number
  name: string
  quantity: number
}

export interface ReleaseResult {
  affectedProducts: number
  totalQuantity: number
}

export interface RemoveResult {
  id: number
  number: string
  amount: number
}

class ReservedInventoryService {
  getReserved = async (warehouseId: number): Promise<ReservedInventoryItem[]> => {
    const response = await $http.get(`/reserved-inventory/warehouse/${warehouseId}`)
    return response.data
  }

  release = async (warehouseId: number): Promise<ReleaseResult> => {
    const response = await $http.post(
      `/reserved-inventory/warehouse/${warehouseId}/release`,
    )
    return response.data
  }

  remove = async (warehouseId: number): Promise<RemoveResult> => {
    const response = await $http.post(
      `/reserved-inventory/warehouse/${warehouseId}/remove`,
    )
    return response.data
  }
}

export default new ReservedInventoryService()
